import React, { useContext } from 'react';
import { Context } from '../../context/news_search.context';
import { Modal } from 'react-bootstrap-v5';

interface Props {
  onAlertActivationClick: (periodicity: 'Daily' | 'Weekly') => void;
}

const ModalAlertStatus: React.FC<Props> = ({ onAlertActivationClick }) => {
  const { showStatusModal, setShowStatusModal, editedSavedSearch, setEditedSavedSearch } =
    useContext(Context);

  const onCancelClick = (): void => {
    setShowStatusModal(false);
    setEditedSavedSearch({});
  };

  return (
    <Modal
      size={'lg'}
      show={showStatusModal}
      onHide={onCancelClick}
      animation={false}
      aria-labelledby='Alert status modal'
    >
      <Modal.Header closeButton className='ps-45 pe-4'>
        <h2 className='modal-title fs-2' data-testid='modal-status-alert-edition'>
          Activate alert
        </h2>
      </Modal.Header>
      <Modal.Body className='px-45 pt-35 mb-25'>
        <p className='text-gray'>
          You are about to activate an alert for &quot;{editedSavedSearch.title}&quot;. You will
          receive the latest relevant articles in your email. Please choose how often you would like
          to receive this alert:
        </p>
        <div className='d-inline-flex align-items-center w-100'>
          <button
            className='btn btn-outline-primary w-100 mx-3'
            onClick={() => onAlertActivationClick('Daily')}
          >
            Daily
          </button>
          <button
            className='btn btn-outline-primary w-100 mx-3'
            onClick={() => onAlertActivationClick('Weekly')}
          >
            Weekly
          </button>
        </div>
      </Modal.Body>
      <Modal.Footer className='px-45'>
        <button className='btn btn-link link-blue-orange me-3' onClick={onCancelClick}>
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAlertStatus;
